import type { SiteImageData } from "@/types/SiteImageData";
import Background from "./Background.png";

export const BackgroundImage: SiteImageData = {
    src: Background,
    alt: `A large, metallic spherical construct suspended in the middle of an dark room, a woman stares at it from a staircase`,
};
